import {useMutation} from '@apollo/react-hooks';

import type {
    UpdateGroup as UpdateGroupMutation,
    UpdateGroupVariables as UpdateGroupMutationVariables,
    EmailSequenceTemplateGroupUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_GROUP from '../mutations/update-group.graphql';

export function useUpdateEmailSequenceTemplateGroup(): {
    updateGroup: (arg1: EmailSequenceTemplateGroupUpdateInput) => Promise<any>;
    isUpdating: boolean;
} {
    const [updateGroup, {loading}] = useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(
        UPDATE_GROUP
    );

    return {
        updateGroup: (input: EmailSequenceTemplateGroupUpdateInput) =>
            updateGroup({
                variables: {input},
            }),
        isUpdating: loading,
    };
}
